import { useEffect } from 'react';
import { Route } from '../models/router';
import type { IRoute } from '@wix/app-market-core-types';
import type { RouterData } from '../models/junk-yard';

interface UsePageLoadParams {
  route: IRoute;
  oldRoute: RouterData['route'];
  onLoad: () => void;
  deps?: string[];
}

export const usePageLoad = ({
  route,
  oldRoute,
  onLoad,
  deps = [],
}: UsePageLoadParams) => {
  useEffect(() => {
    const oldRouteJSON = Route.fromOldRoute(oldRoute).toJSON();
    const routeClass = new Route({ ...route, baseURL: undefined });
    if (routeClass.contains(oldRouteJSON)) {
      onLoad();
    }
  }, [JSON.stringify(route), JSON.stringify(oldRoute), ...deps]);
};
